export default __webpack_public_path__ + "static/media/mockEpic.500221ad.png";